import {SimpleEditor} from "./SimpleEditor.js";
import {Temp} from "../utils/Temp.js";

export class SelectEditor extends SimpleEditor {
	constructor(parent, fieldPath, obj, member, widgetOptions) {
		super(parent, fieldPath, obj, member, widgetOptions);
	}

	rebuild() {
		this.widget = this.root = this.makeSelectElement();
		this.updateScreen();
		// bind
		this.widget.on('change', function () {
			this.updateData();
		}.bind(this));
	}

	makeSelectElement() {
		return Temp.select(this.options);
	}

	changeOptions(items) {
		this.root.empty();
		const d = this.data;
		let first = null;
		let selected = false;
		for (let i = 0; i < items.length; i++) {
			let op = Temp.option(items[i]);
			if (first === null) first = op;
			if (d == items[i].value) {
				op.attr('selected', 'selected');
				selected = true;
			}
			this.root.append(op);
		}
		if (!selected && first !== null) {
			first.attr('selected', 'selected');
		}
		this.updateData();
	}
}


export class IntSelectEditor extends SelectEditor {
	constructor(parent, fieldPath, obj, member, widgetOptions) {
		super(parent, fieldPath, obj, member, widgetOptions);
	}
	fromData(d) { return d == null ? '0' : d.toString(); }
	toData(d) { return d == null ? 0 : parseInt(d); }
}
